/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCDownIcon16Light } from './ArrowCDownIcon16Light';
import { ArrowCDownIcon16Regular } from './ArrowCDownIcon16Regular';
import { ArrowCDownIcon16Solid } from './ArrowCDownIcon16Solid';
import { ArrowCDownIcon20Light } from './ArrowCDownIcon20Light';
import { ArrowCDownIcon20Regular } from './ArrowCDownIcon20Regular';
import { ArrowCDownIcon20Solid } from './ArrowCDownIcon20Solid';
import { ArrowCDownIcon24Regular } from './ArrowCDownIcon24Regular';
import { ArrowCDownIcon24Solid } from './ArrowCDownIcon24Solid';
import { ArrowCDownIcon32Regular } from './ArrowCDownIcon32Regular';
import { ArrowCDownIcon64Regular } from './ArrowCDownIcon64Regular';
var sizes = {
    16: {
        light: ArrowCDownIcon16Light,
        regular: ArrowCDownIcon16Regular,
        solid: ArrowCDownIcon16Solid,
    },
    20: {
        light: ArrowCDownIcon20Light,
        regular: ArrowCDownIcon20Regular,
        solid: ArrowCDownIcon20Solid,
    },
    24: {
        regular: ArrowCDownIcon24Regular,
        solid: ArrowCDownIcon24Solid,
    },
    32: {
        regular: ArrowCDownIcon32Regular,
    },
    64: {
        regular: ArrowCDownIcon64Regular,
    },
};
export var ArrowCDownIcon = forwardRef('ArrowCDownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
